import styled from 'styled-components';
import { Button as BootstrapButton } from 'react-bootstrap';

const Button = styled(BootstrapButton).attrs((props) => ({
  disabled: props.disabled || undefined,
}))``;

export { Button };
